var styles = {"box":"SearchModal_box_1y7he_1","header":"SearchModal_header_1y7he_7","body":"SearchModal_body_1y7he_14","with-navbar":"SearchModal_with-navbar_1y7he_17","scroll":"SearchModal_scroll_1y7he_39","navigation":"SearchModal_navigation_1y7he_58","list":"SearchModal_list_1y7he_64","empty":"SearchModal_empty_1y7he_102"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
